export default {
  title: 'Älykkään hinnoittelusäännön kuva',
  select: {
    generate_title: 'Luo kuva tekoälyllä',
    generate_subtitle: 'Luomme kuvan älykkään hinnoittelusääntösi perusteella.',
    generate_cta: 'Luo',
    upload_link: 'tai lataa laitteeltasi',
    rate_limit_company: {
      title: 'Hetki vielä, otamme kiinni',
      description: 'Ravintolasi on luonut paljon kuvia tämän tunnin aikana. Yritä uudelleen {{time}} kuluttua.',
    },
    rate_limit_smart_pricing_rule: {
      title: 'Pieni hengähdystauko',
      description:
        'Näyttää siltä, että olet kokeillut tätä sääntöä muutaman kerran peräkkäin. Olemme valmiina taas {{time}} kuluttua.',
    },
  },
  generating: {
    title: 'Luodaan kuvaasi…',
    progress: {
      cooking: 'Valmistellaan jotain herkullista…',
      plating: 'Asetellaan lautaselle…',
      finishing: 'Viimeistellään…',
    },
  },
  preview: {
    alt: 'Luotu älykkään hinnoittelusäännön kuva',
    hint: 'Ei ihan oikein? Luo uudelleen tai jatka kuvan rajaamiseen.',
    click_to_expand: 'Napsauta suurentaaksesi',
    regenerate: 'Luo uudelleen',
    continue: 'Jatka muokkaukseen',
  },
  toasts: {
    upload_success: 'Kuva ladattu onnistuneesti.',
    upload_failed: 'Kuvan lataaminen epäonnistui.',
    delete_success: 'Kuva poistettu onnistuneesti.',
    delete_failed: 'Kuvan poistaminen epäonnistui.',
    generate_success: 'Kuva luotu onnistuneesti.',
    generate_failed: 'Kuvan luonnin aloittaminen epäonnistui.',
    generate_timeout: 'Kuvaa luodaan vielä. Se ilmestyy tähän, kun se on valmis.',
    rate_limit_company: 'Tämän ravintolan tuntikohtainen kuvaraja saavutettu. Yritä uudelleen {{time}} kuluttua.',
    rate_limit_smart_pricing_rule:
      'Hieman liian monta yritystä tälle säännölle juuri nyt — yritä uudelleen {{time}} kuluttua.',
  },
  time: {
    seconds_one: '1 sekunti',
    seconds_other: '{{count}} sekuntia',
    minutes_one: '1 minuutti',
    minutes_other: '{{count}} minuuttia',
    hours_one: '1 tunti',
    hours_other: '{{count}} tuntia',
  },
};
